import { cn } from '@client/lib';
import { AccountType, ASSET_OPTIONS, type AssetOption } from '@client/util/constants';
import { Check } from 'lucide-react';

export { ASSET_OPTIONS };
export type { AssetOption };

interface AssetSelectionGridProps {
  className?: string;
  selectedAssets: AccountType[];
  onToggleAsset: (accountType: AccountType) => void;
}

export function AssetSelectionButton(props: {
  asset: AssetOption;
  isSelected: boolean;
  onToggleAsset: (accountType: AccountType) => void;
}) {
  const { asset, isSelected, onToggleAsset } = props;

  return (
    <button
      type="button"
      onClick={() => onToggleAsset(asset.label)}
      className={cn(
        'relative flex items-center justify-between rounded-lg border-2 px-4 py-4 text-left transition-all hover:shadow-md',
        {
          'border-primary bg-primary/5': isSelected,
          'border-gray-200 bg-white hover:border-gray-300': !isSelected,
        },
      )}
    >
      <span
        className={cn('text-base font-medium', {
          'text-gray-900': isSelected,
          'text-gray-700': !isSelected,
        })}
      >
        {asset.label}
      </span>

      <div
        className={cn(
          'flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border-2 transition-colors',
          {
            'border-primary bg-primary': isSelected,
            'border-gray-300 bg-white': !isSelected,
          },
        )}
      >
        {isSelected && (
          <Check
            className="h-4 w-4 text-white"
            strokeWidth={3}
          />
        )}
      </div>
    </button>
  );
}

export function AssetSelectionGrid({
  className,
  selectedAssets,
  onToggleAsset,
}: AssetSelectionGridProps) {
  return (
    <div className={cn('grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3', className)}>
      {ASSET_OPTIONS.map(asset => (
        <AssetSelectionButton
          key={asset.type}
          asset={asset}
          isSelected={selectedAssets.includes(asset.label)}
          onToggleAsset={onToggleAsset}
        />
      ))}
    </div>
  );
}
